<template>
    <div>
        <div class="table__box--container">
            <div v-if="inforEditRecord?.isEdit" class="text-right mb-3">
                <div v-if="!isVisibledEdit">
                    <button
                        class="btn btn-common btn-primary"
                        :disabled="dataTable.length <= 0 || isDisabledEditListStatus"
                        @click="handleToggleEditStatus"
                    >
                        <i class="ri-edit-box-line"></i>{{ $t('btn.statusEdit') }}
                    </button>
                </div>
                <div v-else>
                    <button class="btn btn-common-cancel" @click="handleToggleEditStatus">{{ $t('btn.cancel') }}</button>
                    <button class="btn btn-common btn-success ml-3" @click="handleSaveStatus">{{ $t('btn.save') }}</button>
                </div>
            </div>
            <div class="table-responsive position-relative">
                <table
                    class="table mb-0 table-bordered table-box table-hover table-resize"
                    :style="{ minHeight: dataTable.length > 0 && !isLoading ? '0px' : '150px' }"
                >
                    <colgroup>
                        <col v-for="(item, colK) in configTableDashboard.headers" :key="colK" :style="{ width: item.width + 'px' }" />
                        <col :style="{ width: configTableDashboard?.widthAction + 'px' }" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th
                                v-for="(item, k) in configTableDashboard.headers"
                                :key="k"
                                class="text-left position-sticky"
                                :colspan="item.colSpan ?? 1"
                                :style="{
                                    width: item.width + 'px',
                                    backgroundColor: item?.backgroundColor,
                                    top: 0,
                                    left: k === 0 ? 0 : k === 1 ? codeColWidth : 'auto',
                                    zIndex: k <= 1 ? 20 : 1
                                }"
                            >
                                <div class="el-table__cell">
                                    {{ item.label }}
                                </div>
                            </th>
                            <th :style="{ width: configTableDashboard?.widthAction + 'px' }" :class="`text-center sticky_action`"></th>
                        </tr>
                    </thead>
                    <tbody v-if="dataTable.length > 0 && !$props.isLoading">
                        <template v-for="row in dataTable">
                            <Transition name="slide-fade__table--list" appear :key="row.id">
                                <tr :class="`${row?.edited_status ? 'active--edited' : ''}`">
                                    <td
                                        class="text-left position-sticky sticky-col-bg"
                                        :style="{ left: 0, zIndex: 10 }"
                                        v-b-tooltip.hover
                                        :title="row?.code"
                                    >
                                        {{ row?.code }}
                                    </td>
                                    <td class="text-left position-sticky sticky-col-bg" :style="{ left: codeColWidth, zIndex: 10 }">
                                        <InlineEditWrapper
                                            :is-editing="isEditingInline(row.id, 'name', inlineEdit)"
                                            :show-edit-icon="inforEditRecord?.isEdit"
                                            :tooltip="row.name"
                                            @start="onHandleStartInlineEdit(row, 'name')"
                                            @save="onHandleSaveCampaignInline(row, 'name')"
                                            @cancel="onHandleCancelInlineEdit()"
                                        >
                                            <template #input>
                                                <InputText
                                                    :style="{ width: '100%' }"
                                                    :model.sync="inlineEdit.value"
                                                    :config.sync="inlineEdit.config"
                                                    @blur="handleValidateFieldInline(inlineEdit.value, inlineEdit.config)"
                                                />
                                            </template>
                                            <template #display>
                                                <span class="text-truncate">{{ row.name }}</span>
                                            </template>
                                        </InlineEditWrapper>
                                    </td>
                                    <td class="text-left">
                                        <InlineEditWrapper
                                            :is-editing="isEditingInline(row.id, 'sale_staff_id', inlineEdit)"
                                            :show-edit-icon="inforEditRecord?.isEdit"
                                            @start="onHandleStartInlineEdit(row, 'sale_staff_id')"
                                            @save="onHandleSaveCampaignInline(row, 'sale_staff_id')"
                                            @cancel="onHandleCancelInlineEdit()"
                                        >
                                            <template #input>
                                                <Multiselect
                                                    :id="`select-sale-staff-inline-${row.id}`"
                                                    :value.sync="inlineEdit.value"
                                                    :options="listSaleStaff"
                                                    :config.sync="inlineEdit.config"
                                                />
                                            </template>
                                            <template #display>
                                                <span class="text-truncate">{{ row.sale_staff ? row.sale_staff.name : '' }}</span>
                                            </template>
                                        </InlineEditWrapper>
                                    </td>
                                    <td class="text-left">
                                        <InlineEditWrapper
                                            :is-editing="isEditingInline(row.id, 'person_in_charge_id', inlineEdit)"
                                            :show-edit-icon="inforEditRecord?.isEdit"
                                            @start="onHandleStartInlineEdit(row, 'person_in_charge_id')"
                                            @save="onHandleSaveCampaignInline(row, 'person_in_charge_id')"
                                            @cancel="onHandleCancelInlineEdit()"
                                        >
                                            <template #input>
                                                <Multiselect
                                                    :id="`select-person-inline-${row.id}`"
                                                    :value.sync="inlineEdit.value"
                                                    :options="listPIC"
                                                    :config.sync="inlineEdit.config"
                                                />
                                            </template>
                                            <template #display>
                                                <span class="text-truncate">{{ row.person_in_charge ? row.person_in_charge.name : '' }}</span>
                                            </template>
                                        </InlineEditWrapper>
                                    </td>
                                    <td class="text-left">
                                        <div
                                            class="el-table__cell"
                                            v-b-tooltip.hover
                                            :title="row.responsible_sub_persons?.find((item) => item.sub_person_position === 1)?.name ?? ''"
                                        >
                                            {{ row.responsible_sub_persons?.find((item) => item.sub_person_position === 1)?.name ?? '' }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div
                                            class="el-table__cell"
                                            v-b-tooltip.hover
                                            :title="formatDateCommon(row.campaign_start_date, 'dateTimeJP')"
                                        >
                                            {{ formatDateCommon(row.campaign_start_date, 'dateTimeJP') }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="formatDateCommon(row.campaign_end_date, 'dateTimeJP')">
                                            {{ formatDateCommon(row.campaign_end_date, 'dateTimeJP') }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div
                                            class="el-table__cell"
                                            v-b-tooltip.hover
                                            :title="formatDateCommon(row.secretariat_start_date, 'dateTimeJP')"
                                        >
                                            {{ formatDateCommon(row.secretariat_start_date, 'dateTimeJP') }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div
                                            class="el-table__cell"
                                            v-b-tooltip.hover
                                            :title="formatDateCommon(row.secretariat_end_date, 'dateTimeJP')"
                                        >
                                            {{ formatDateCommon(row.secretariat_end_date, 'dateTimeJP') }}
                                        </div>
                                    </td>
                                    <td class="text-left" :style="`background-color:${row?.edited_status ? '' : onHandleBgr(row.progress_status)}`">
                                        <div class="text-center">
                                            <template v-if="isVisibledEdit">
                                                <Multiselect
                                                    :id="`select-progres-status-dashboard-${row.id}`"
                                                    :value.sync="row.progress_status"
                                                    :options="campaignStatus"
                                                    :config="{ trackBy: 'id', label: 'text', error: false, isRemove: true }"
                                                    class="select_dasboard_all"
                                                    :disabled="!isVisibledEdit"
                                                    @select="onHandleChangeStatus(row)"
                                                />
                                            </template>
                                            <template v-else>
                                                <InlineEditWrapper
                                                    :is-editing="isEditingInline(row.id, 'progress_status', inlineEdit)"
                                                    :show-edit-icon="inforEditRecord?.isEdit"
                                                    @start="onHandleStartInlineEdit(row, 'progress_status')"
                                                    @save="onHandleSaveCampaignInline(row, 'progress_status')"
                                                    @cancel="onHandleCancelInlineEdit()"
                                                >
                                                    <template #input>
                                                        <Multiselect
                                                            :id="`select-progres-status-dashboard-${row.id}`"
                                                            :value.sync="inlineEdit.value"
                                                            :options="campaignStatus"
                                                            :config.sync="inlineEdit.config"
                                                            class="select_dasboard_all"
                                                            @select="onHandleChangeStatus(row)"
                                                        />
                                                    </template>
                                                    <template #display>
                                                        {{ renderNameProgress(row.progress_status?.id || row.progress_status) }}
                                                    </template>
                                                </InlineEditWrapper>
                                            </template>
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="row?.campaign_type?.value">
                                            {{ row.campaign_type ? row.campaign_type.value : '' }}
                                        </div>
                                    </td>

                                    <td class="text-left">
                                        <div
                                            class="el-table__cell"
                                            v-b-tooltip.hover
                                            :title="row.categories?.map((item) => item.value).join('・') ?? ''"
                                        >
                                            {{ row.categories?.map((item) => item.value).join('・') ?? '' }}
                                        </div>
                                    </td>

                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="renderNameClientFile(row.client_generate_file)">
                                            {{ renderNameClientFile(row.client_generate_file) }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="row?.client_order_source?.name">
                                            {{ row.client_order_source ? row.client_order_source.name : '' }}
                                        </div>
                                    </td>

                                    <td class="text-left">
                                        <div
                                            class="el-table__cell"
                                            v-b-tooltip.hover
                                            :title="
                                                row.event_prizes?.length > 0
                                                    ? row.event_prizes.reduce((sum, item) => sum + item.number_of_win_prize, 0)
                                                    : ''
                                            "
                                        >
                                            {{
                                                row.event_prizes?.length > 0
                                                    ? row.event_prizes.reduce((sum, item) => sum + item.number_of_win_prize, 0)
                                                    : ''
                                            }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="row.url ?? ''">
                                            <a :href="row.url" target="_blank">
                                                {{ row.url ?? '' }}
                                            </a>
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="row?.phone_setting_contact_information ?? ''">
                                            {{ row.phone_setting_contact_information ? row.phone_setting_contact_information : '' }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div
                                            class="el-table__cell"
                                            v-b-tooltip.hover
                                            :title="
                                                row.contact_informations?.length > 0
                                                    ? row.contact_informations.find((item) => item.type.id === 5)?.extension?.content
                                                    : ''
                                            "
                                        >
                                            {{
                                                row.contact_informations?.length > 0
                                                    ? row.contact_informations.find((item) => item.type.id === 5)?.extension?.content
                                                    : ''
                                            }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="row?.mos_partner_inquiries">
                                            {{ row.mos_partner_inquiries }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <InlineEditWrapper
                                            :is-editing="isEditingInline(row.id, 'inquiries', inlineEdit)"
                                            :show-edit-icon="inforEditRecord?.isEdit"
                                            type="textarea"
                                            @start="onHandleStartInlineEdit(row, 'inquiries')"
                                            @save="onHandleSaveCampaignInline(row, 'inquiries')"
                                            @cancel="onHandleCancelInlineEdit()"
                                        >
                                            <template #input>
                                                <TextareaComponent :model.sync="inlineEdit.value" :rows="`5`"></TextareaComponent>
                                            </template>
                                            <template #display>
                                                <span class="text-multi-truncate">{{ row?.campaign_content_other?.inquiries ?? '' }}</span>
                                            </template>
                                        </InlineEditWrapper>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="row?.customer_team_pic?.name">
                                            {{ row.customer_team_pic ? row.customer_team_pic.name : '' }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="row?.customer_sub_person[0]?.name">
                                            {{ row.customer_sub_person?.length > 0 ? row.customer_sub_person[0].name : '' }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div
                                            class="el-table__cell"
                                            v-b-tooltip.hover
                                            :title="
                                                row.campaign_master_order_scopes?.length > 0
                                                    ? row.campaign_master_order_scopes.map((item) => item.large_item.value).join('・')
                                                    : ''
                                            "
                                        >
                                            {{
                                                row.campaign_master_order_scopes?.length > 0
                                                    ? row.campaign_master_order_scopes.map((item) => item.large_item.value).join('・')
                                                    : ''
                                            }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="renderLargeItemPartnerUnique(row)">
                                            {{ renderLargeItemPartnerUnique(row) }}
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        <div
                                            class="el-table__cell"
                                            v-b-tooltip.hover
                                            :title="
                                                row.campaign_master_order_scope_partner?.length > 0
                                                    ? row.campaign_master_order_scope_partner
                                                          .map((item) => {
                                                              if (item.tool) return item.tool.tool;
                                                          })
                                                          .filter((item, index, self) => item && self.indexOf(item) === index)
                                                          .join('・')
                                                    : ''
                                            "
                                        >
                                            {{
                                                row.campaign_master_order_scope_partner?.length > 0
                                                    ? row.campaign_master_order_scope_partner
                                                          .map((item) => {
                                                              if (item.tool) return item.tool.tool;
                                                          })
                                                          .filter((item, index, self) => item && self.indexOf(item) === index)
                                                          .join('・')
                                                    : ''
                                            }}
                                        </div>
                                    </td>
                                    <td align="center" class="sticky_action" style="z-index: 55">
                                        <div class="row-data-small ml-2">
                                            <a
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-info mr-2"
                                                @click="goToDetail('/campaign/form/view', row)"
                                                ><i class="ri-file-list-2-line"></i>{{ $t('btn.detail') }}</a
                                            >
                                            <a
                                                v-if="row?.is_approved != 0 && row?.is_locked != 1 && checkPermission('campaign.edit')"
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-primary mr-2"
                                                @click="goToDetail('/campaign/edit', row)"
                                                ><i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}</a
                                            >
                                            <a
                                                v-if="
                                                    row?.is_approved != 0 &&
                                                    row?.is_locked != 1 &&
                                                    checkPermission('campaign.edit') &&
                                                    checkPermission('campaign.register')
                                                "
                                                v-b-tooltip.hover="`${$t('pageCampaign.document')}`"
                                                href="javascript:void(0)"
                                                @click="goToDetail('/documents', row)"
                                                class="btn btn-only-icon-sml btn-outline-primary"
                                                ><i class="ri-file-list-2-line"></i
                                            ></a>
                                        </div>
                                    </td>
                                </tr>
                            </Transition>
                        </template>
                    </tbody>
                    <tbody v-else-if="$props.isLoading">
                        <template>
                            <tr style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); border: none">
                                <td style="border: none">
                                    <div
                                        class="d-flex justify-content-center position-absolute"
                                        style="left: 50%; top: 50%; transform: translate(-50%, -50%)"
                                    >
                                        <LoadingIcon />
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <template>
                            <Transition name="slide-fade__table--list" appear>
                                <tr style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%)">
                                    <td style="border: none">
                                        <p class="mt-3 text-center">
                                            {{ $t('notificationCommon.noData') }}
                                        </p>
                                    </td>
                                </tr>
                            </Transition>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <Pagination
            v-if="configPageDefault.total"
            :total="configPageDefault.total"
            :page.sync="configPageDefault.page"
            :per-page="configPageDefault.limit"
            @changePage="onChangePage"
        ></Pagination>
    </div>
</template>

<script>
import { campaignStatus } from '@/config/var-common';
import { formatDateCommon } from '@/utils/format';
import { campaignMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { cloneDeep } from 'lodash';
import { checkPermission } from '@/utils/handlers';
import { configTableDashboard } from './constants';
import { InputText } from '@/components/Input';

import LoadingIcon from '@/components/Loading/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import Pagination from '@/components/Pagination/main.vue';
import TextareaComponent from '@/components/Textarea/main.vue';
import inlineEditCampaignMixin from '@/mixins/inlineEditCampaignMixin';
import InlineEditWrapper from '@/views/pages/campaign/components/edit-quick-field/InlineEditWrapper.vue';

export default {
    components: {
        LoadingIcon,
        Multiselect,
        Pagination,
        InputText,
        TextareaComponent,
        InlineEditWrapper
    },
    props: {
        listData: {
            type: Array,
            required: true
        },
        inforPage: {
            type: Object,
            default: () => null
        },
        inforEditRecord: {
            type: [String, Number, Object]
        },
        isLoading: {
            type: Boolean,
            require: false,
            default: () => false
        }
    },
    mixins: [inlineEditCampaignMixin],
    data() {
        return {
            campaignStatus,
            configTableDashboard,
            listDataClone: [],
            dataTable: [],
            configPageDefault: {
                page: 1,
                limit: 10,
                total: 5
            }
        };
    },
    computed: {
        codeColWidth() {
            return (this.configTableDashboard?.headers?.[0]?.width || 100) + 'px';
        }
    },
    methods: {
        ...campaignMethods,
        formatDateCommon,
        checkPermission,

        goToDetail(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },

        goToView(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },

        handleToggleEditStatus() {
            this.isVisibledEdit = !this.isVisibledEdit;
            if (!this.isVisibledEdit) {
                this.dataTable?.forEach((ord) => {
                    const founDataClone = this.listDataClone.find((itd) => itd.id === ord.id);
                    if (founDataClone) {
                        ord.progress_status = founDataClone.progress_status;
                    }
                    if (ord?.edited_status) ord.edited_status = false;
                });
            }
        },

        renderNameProgress(params) {
            return campaignStatus.find((item) => item.id === params)?.text;
        },

        async handleSaveStatus() {
            let payload = {
                campaigns: this.listData.map((itemTable) => {
                    return {
                        id: itemTable?.id ?? null,
                        progress_status: itemTable?.progress_status?.id ?? null
                    };
                })
            };
            try {
                const requestStatusCP = await this.updateMassStatusCampaign(payload);
                if (requestStatusCP?.code !== 200) {
                    showMessage(requestStatusCP.code, this.$bvToast, requestStatusCP?.message);
                    return;
                }
                this.isVisibledEdit = false;
                this.$emit('refresh');
            } catch (error) {
                console.log('error', error);
            }
        },

        onHandleChangeStatus(paramsRecord) {
            let { progress_status, id } = paramsRecord;
            paramsRecord.edited_status = this.listDataClone?.some((ocl) => ocl.id === id && progress_status?.id !== ocl?.progress_status?.id);
        },

        onHandleBgr(objb) {
            const foundStt = campaignStatus.find((item) => item.id === objb?.id);
            return foundStt?.backgroundColor;
        },

        renderNameClientFile(clientGenerateFile) {
            if (!clientGenerateFile) return '';
            return clientGenerateFile?.name ?? '';
        },

        renderLargeItemPartnerUnique(largeItemPartner) {
            if (largeItemPartner.mos_partner_secretariat_related_names && largeItemPartner.mos_partner_shipping_names)
                return largeItemPartner.mos_partner_secretariat_related_names.concat('・', largeItemPartner.mos_partner_shipping_names);
            if (largeItemPartner.mos_partner_secretariat_related_names && !largeItemPartner.mos_partner_shipping_names)
                return largeItemPartner.mos_partner_secretariat_related_names;
            if (!largeItemPartner.mos_partner_secretariat_related_names && largeItemPartner.mos_partner_shipping_names)
                return largeItemPartner.mos_partner_shipping_names;
        },
        onChangePage() {
            this.$emit('onChangePage');
        }
    },

    watch: {
        listData: {
            handler: function (newData) {
                this.dataTable = newData;
                this.listDataClone = cloneDeep(newData);
            },
            immediate: true
        },
        inforPage: {
            handler: function (newConfig) {
                this.configPageDefault = newConfig;
            },
            immediate: true,
            deep: true
        },

        configPageDefault: {
            handler: function (newConfig) {
                this.$emit('update:inforPage', newConfig);
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {}
};
</script>

<style lang="scss">
.box--select.select_dasboard_all {
    .multiselect__content-wrapper {
        max-height: 200px !important;
    }
}
.active--edited {
    background-color: #1cbb8c70 !important;
}
.sticky-col-bg {
    background-color: #ffffff;
}
tr:hover .sticky-col-bg {
    background-color: #f8f9fa;
}
tr.active--edited .sticky-col-bg {
    background-color: #1cbb8c70 !important;
}
</style>
